<template>
  <div class="card">
    <div class="card-body">
      <a-tabs :active-key="activeTab" @change="handleTabChange">
        <a-tab-pane :tab="$t('bulletin.parEleve')" key="1">
          <ByStudent
            v-if="activeTab === '1'"
            ref="byStudent"
            :key="`by-student-${activeTab}`"
            @unsaved-changes="handleUnsavedChanges"
          />
        </a-tab-pane>
        <a-tab-pane :tab="$t('bulletin.parMatiere')" key="2">
          <BySubject
            v-if="activeTab === '2'"
            ref="bySubject"
            :key="`by-subject-${activeTab}`"
            @unsaved-changes="handleUnsavedChanges"
          />
        </a-tab-pane>
        <a-tab-pane :tab="$t('menu.certificate')" key="3">
          <Certification
            v-if="activeTab === '3'"
            :key="`certification-${activeTab}`"
            type="college"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import ByStudent from "./components/ByStudent.vue";
import BySubject from "./components/BySubject.vue";
import Certification from "@/views/bulletinv2/certification/index.vue";

export default {
  name: "BulletinCollegeStudentMarks",
  components: {
    ByStudent,
    BySubject,
    Certification,
  },
  data() {
    return {
      activeTab: "1",
      hasUnsavedChanges: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasUnsavedChanges) {
      next();
      return;
    }

    const _this = this;
    this.$confirm({
      title: this.$t("all.unsavedchanges"),
      content: this.$t("all.unsavedChangesLeaveConfirm"),
      okText: this.$t("all.oui"),
      okType: "danger",
      cancelText: this.$t("action.annuler"),
      onOk() {
        // Reset unsaved changes
        _this.hasUnsavedChanges = false;
        // Also reset in child components if they exist
        if (_this.$refs.byStudent) {
          _this.$refs.byStudent.hasUnsavedChanges = false;
        }
        if (_this.$refs.bySubject) {
          _this.$refs.bySubject.hasUnsavedChanges = false;
        }
        next();
      },
      onCancel() {
        next(false);
      },
    });
  },
  methods: {
    async handleTabChange(key) {
      // If trying to change to the same tab, allow it
      if (key === this.activeTab) {
        return;
      }

      if (this.hasUnsavedChanges) {
        const _this = this;
        const confirmed = await new Promise((resolve) => {
          this.$confirm({
            title: this.$t("all.unsavedchanges"),
            content: this.$t("all.unsavedChangesLeaveConfirm"),
            okText: this.$t("all.oui"),
            okType: "danger",
            cancelText: this.$t("action.annuler"),
            onOk() {
              // Reset unsaved changes
              _this.hasUnsavedChanges = false;
              // Also reset in child components if they exist
              if (_this.$refs.byStudent) {
                _this.$refs.byStudent.hasUnsavedChanges = false;
              }
              if (_this.$refs.bySubject) {
                _this.$refs.bySubject.hasUnsavedChanges = false;
              }
              resolve(true);
            },
            onCancel() {
              resolve(false);
            },
          });
        });

        if (!confirmed) {
          // User cancelled, don't change tab
          // activeTab hasn't changed, so the tab will stay the same
          return;
        }
      }

      // No unsaved changes or user confirmed, proceed with tab change
      this.activeTab = key;
    },
    handleUnsavedChanges(hasChanges) {
      this.hasUnsavedChanges = hasChanges;
    },
  },
};
</script>
